import { render, staticRenderFns } from "./Myauth.vue?vue&type=template&id=2f70c612&scoped=true"
import script from "./Myauth.vue?vue&type=script&lang=js"
export * from "./Myauth.vue?vue&type=script&lang=js"
import style0 from "./Myauth.vue?vue&type=style&index=0&id=2f70c612&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70c612",
  null
  
)

export default component.exports